"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _TopicReplyCount = require("@insided/destination/uikit/TopicReplyCount");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var TopicComments = function TopicComments(_ref) {
  var lastPostUrl = _ref.lastPostUrl,
      numberOfReplies = _ref.numberOfReplies,
      numberOfUnreadReplies = _ref.numberOfUnreadReplies,
      id = _ref.id;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--comments', 'thread-meta-item--hover-highlight')
  }, (0, _preact.h)("a", {
    className: "qa-topic-meta-replies-icon",
    href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl)
  }, (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
    replyCount: numberOfReplies
  })), numberOfUnreadReplies ? (0, _preact.h)("span", {
    className: "thread-meta-item__text thread-meta-bullet"
  }, (0, _preact.h)("span", {
    className: "icon--bullet icon--auto-width"
  })) : null, numberOfUnreadReplies ? (0, _preact.h)("a", {
    className: "thread-meta-item__text--highlight qa-topic-meta-new",
    href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/topic/firstNewPostRedirect?topicId=").concat(id))
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__text--highlight"
  }, (0, _preact.h)(_phrase.default, {
    p: "forumList.meta.counter.post.user.new",
    count: {
      n: numberOfUnreadReplies.toString()
    }
  }))) : null);
};

var _default = TopicComments;
exports.default = _default;